<template>
  <public-header></public-header>
  <div id="spacer"></div>
  <div id="content">
    <div class="div1">
      <h1 id="mainhead">
        Testimonials
      </h1>
      <div id="box3">
        <p id="descript1">
          "CompuTales has been a fantastic tool for enhancing both student engagement and comprehension. 
          Its interactive approach has made complex concepts much easier to grasp, especially in areas 
          like computational thinking and problem-solving."
          <br/>Lisa Lang, Computer Teacher, Hillsdale, NJ
        </p>
        <p id="descript1">
          "As a teacher, I have been using Computales for two years now. My kindergartners and first graders
           absolutely love it! I love how it combines reading, literacy, and a story with computational thinking 
           algorithms, and other logic puzzles.  parents ask me about it I - I rave a bout the program for the 
           children. I am very thankful for this resource."
          <br/>Angela Hickey, Computer/Robotics Teacher, Wellesley, MA
        </p>
        <p id="descript1">
          "My 1st-grade Technology students use Computales for the first 15 minutes of technology class weekly.
           They have not only learned about technology, but they also get math and ela practice. I LOVE this 
           program for my kids and they are so excited to see what happens when they get to the rainbow portal
           at the end of the path!"
          <br/>Shelly Divito, Technology Teacher, Huntersville, NC
        </p>
      </div>
    </div>
    
    
    <div class="footer">
      <div id="content4">
        <div id="brandinfo">
          <img alt="CompuTales Logo" src="../assets/images/logo3.png" /><br />
          CompuTales helps students to learn the building blocks of Computer
          Science with a fun and interactive story. Narrated for emerging
          readers, and aligned to CSTA standards for K-2.
        </div>
        <div id="aboutinfo">
          <p id="header-heading">
            <router-link :to="{ name: 'about' }" class="link-footer"
              >About</router-link
            >
          </p>
          <ul class="no-bullets">
            <li>Our Why</li>
            <li>How It Works</li>
            <li>Features</li>
          </ul>
        </div>
        <div id="educatorinfo">
          <p id="header-heading">
            <router-link :to="{ name: 'educators' }" class="link-footer"
              >Educators</router-link
            >
          </p>
          <ul class="no-bullets">
            <li>Curriculum</li>
            <li>Benefits</li>
            <li>FAQs</li>
          </ul>
        </div>
        <div id="storeinfo">
          <p id="header-heading">
            <router-link :to="{ name: 'store' }" class="link-footer"
              >Store</router-link
            >
          </p>
          <ul class="no-bullets">
            <li>Workbooks</li>
            <li>Subscribe</li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div id="connectinfo">
          <p id="header-heading">
            <router-link :to="{ name: 'contact' }" class="link-footer"
              >Connect With Us</router-link
            >
          </p>
          <ul class="no-bullets">
            <li>Contact</li>
            <li>&nbsp;</li>
            <li>&nbsp;</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PublicHeader from '@/components/Public-Header';
export default {
  name: 'StoreView',
  components: {
    'public-header': PublicHeader
  }
};
</script>

<style scoped>
@media only screen and (min-width: 901px) {
  div.div1 {
    font-size: 20px;
  }
}

@media only screen and (max-width: 900px) {
  div.div1 {
    font-size: 14px;
  }
}

@media only screen and (min-width: 901px) {
  div.div2 {
    font-size: 20px;
  }
}

@media only screen and (max-width: 900px) {
  div.div2 {
    font-size: 14px;
  }
}

@media (min-width: 901px) {
  h1 {
    font-size: 36px;
  }
}

@media (max-width: 900px) {
  h1 {
    font-size: 24px;
  }
}

@media (max-width: 1600px) {
  div#connectinfo {
    display: none;
  }
}

@media (max-width: 1300px) {
  div#storeinfo {
    display: none;
  }
}

@media (max-width: 1000px) {
  div#educatorinfo {
    display: none;
  }
}

@media (max-width: 800px) {
  div#aboutinfo {
    display: none;
  }
}

@media (max-width: 1400px) {
  img#gang {
    display: none;
  }
}

div.div1 {
  margin-top: 86px;
  text-align: center;
  display: inline-block;
  width: 55%;
}

div.div2 {
  text-align: center;
  display: inline-block;
  width: 60%;
}

#div3 {
  display: inline-block;
  justify-content: center;
  align-items: center;
  padding-bottom: 60px;
  margin: 0px;
  margin-bottom: 200px;
}

.footer {
  background-color: rgb(50, 50, 50);
  clear: both;
  position: relative;
  height: 200px;
  margin-top: 100px;
}

#content {
  text-align: center;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
}

#content3 {
  max-width: 1150px;
}

#content4 {
  width: 70%;
  color: white;
  padding-top: 20px;
  margin: auto;
}

#brandinfo {
  font-size: 14px;
  width: 320px;
  float: left;
  text-align: left;
  line-height: 1.6;
}

#aboutinfo {
  width: 140px;
  text-align: left;
  line-height: 1.6;
  margin-left: 50px;
  display: inline-block;
}

#educatorinfo {
  width: 140px;
  display: inline-block;
  text-align: left;
  line-height: 1.6;
  margin-left: 30px;
}

#storeinfo {
  width: 140px;
  display: inline-block;
  text-align: left;
  line-height: 1.6;
  margin-left: 30px;
}

#connectinfo {
  width: 220px;
  display: inline-block;
  text-align: left;
  line-height: 1.6;
  margin-left: 30px;
}

#header-heading {
  font-size: 16px;
  padding: 0;
  margin-bottom: 0px;
}

ul.no-bullets {
  list-style-type: none;
  padding: 0;
  margin-top: 5px;
  margin-left: 8px;
  font-size: 14px;
}

#mainhead {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 10px;
  margin: 10px;
}

#descript1 {
  text-align: left;
  display: flex;
  line-height: 1.8;
  margin-top: 20px;
  margin-right: 30px;
  font-style: italic;
}

#checkhead {
  font-size: 32px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  margin: 0px;
}

.link {
  font-weight: 500;
  color: blue;
  list-style: none;
  text-decoration: none;
  font-size: 20px;
  transition: 0.5s ease all;
  padding-bottom: 4px;
  border-bottom: 1px solid transparent;
}

.link-footer {
  font-weight: 500;
  color: white;
  list-style: none;
  text-decoration: none;
  font-size: 18px;
  transition: 0.5s ease all;
  padding-bottom: 4px;
  border-bottom: 1px solid transparent;
}

.link:hover {
  color: blue;
  border-color: #00afea;
}

.link-footer:hover {
  color: white;
  border-color: #00afea;
}

ul.features {
  float: left;
  margin-left: 0;
  padding-right: 0;
  margin-top: 0px;
  text-align: left;
}

li.features {
  position: relative;
  padding: 0 0 0 0px;
  margin: 0px;
  font-size: 20px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  text-align: left;
  margin-top: 0.8em;
}

#box1 {
  font-size: 20px;
  padding: 10px;
  width: 440px;
  height: 200px;
  float: left;
  background-color: rgb(203, 252, 205);
  border-radius: 25px;
  border: 4px solid #01a50f;
  line-height: 1.5;
  margin-right: 50px;
  margin-top: 40px;
}

#box2 {
  font-size: 20px;
  padding: 10px;
  width: 440px;
  height: 200px;
  float: right;
  background-color: rgb(203, 252, 205);
  border-radius: 25px;
  border: 4px solid #01a50f;
  line-height: 1.5;
  margin-left: 50px;
  margin-top: 40px;
}

#box3 {
  font-size: 20px;
  max-width: 930px;
  float: left;
  line-height: 1.5;
}

#box4 {
  width: 200px;
  float: right;
}

#box5 {
  width: 200px;
  float: left;
}

#box6 {
  font-size: 20px;
  padding-left: 20px;
  max-width: 900px;
  float: right;
  line-height: 1.5;
}
</style>